import { render } from "./NotificationsMenu.vue?vue&type=template&id=fffe2ccc&ts=true"
import script from "./NotificationsMenu.vue?vue&type=script&lang=ts"
export * from "./NotificationsMenu.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\unnati\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__